// extracted by mini-css-extract-plugin
export default {"alert":"Alert_alert__dV8Ja","upIn":"Alert_upIn__9RtWC","slideAway":"Alert_slideAway__S5-sR","text":"Alert_text__1eIh3"};